import React, { Component } from 'react';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import './../css/mstStock.css';
import './../css/master.css';
import Header from './header.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';


var httpURL = '';
var queryString = require('querystring');
var lstMstStock = [];
var lstStockLocation = [];
var lstDesigns = [];
var lstDesignsColor = [];

class mstStock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flg: true,
            opacity: 1,
            stock: '',
            stockLocation: '',
            loader: 'none',
            startDate: new Date(),
            src: require('./../images/blank.png'),
        }
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(date) {
        this.setState({
            startDate: date
        });
    }

    componentDidMount = () => {
        $('#stockLocationCmb').prepend($("<option> </option>").val(0).html('Stock Location'));

        this.setState({ loader: 'block', opacity: 0.5 });

        axiosInstance.get(httpURL + '/a/mst/sto/list', {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                this.setState({
                    stockLocation: response.data.lstStockLocation,
                })
                lstStockLocation = this.state.stockLocation;
                this.fillStockLocation();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

        this.getStockList();

        axiosInstance.get(httpURL + '/a/mst/dsn/list', {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                this.setState({
                    designNoColor: response.data.lstDesigns,
                })
                lstDesigns = response.data.lstDesigns;
                this.fillDesignColor();

            }
            else {
                toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            toast.error("Service failed " + error);
        });
    }
    getStockList = () => {
        axiosInstance.post(httpURL + '/a/mst/stk/list', queryString.stringify(), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                this.setState({
                    stock: response.data.lstStock,
                })
                lstMstStock = this.state.stock;
                this.setStockTable();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

    }

    fillStockLocation = () => {
        $('#stockLocationCmb').empty();
        $('#stockLocationCmb').prepend($("<option> </option>").val(0).html('Stock Location'));
        for (var i = 0; i < lstStockLocation.length; i++) {
            var stockLocationId = lstStockLocation[i].stockLocationId;
            var stockLocation = lstStockLocation[i].stockLocation;
            $('#stockLocationCmb').append($('<option></option>').val(stockLocationId).html(stockLocation));
        }
    }
    fillDesignColor = () => {
        for (var i = 0; i < lstDesigns.length; i++) {
            var designId = lstDesigns[i].designId;
            var designNoColor = lstDesigns[i].designNoColor;
            var obj = { 'value': designId, 'label': designNoColor }
            lstDesignsColor.push(obj);
        }
    }

    setStockTable = () => {
        $('#stockTableBody tr').remove();
        var table = document.getElementById('stockTable');
        var tbody = document.getElementById('stockTableBody');
        var filterStock = $('#stockLocationFilter').val().toLowerCase();
        var filterDesignColor = $('#designColorFilter').val().toLowerCase();
        var filterBatchNo = $('#batchNoFilter').val().toLowerCase();

        for (var i = 0; i < lstMstStock.length; i++) {

            var id = lstMstStock[i].stockId;
            var stockLocationId = lstMstStock[i].stockLocationId;
            var stockLocation = lstMstStock[i].stockLocation;
            var designId = lstMstStock[i].designId;
            var designNoColor = lstMstStock[i].designNoColor;
            var batchNo = lstMstStock[i].batchNo;
            var folioNo = lstMstStock[i].folioNo;
            var stockDt = lstMstStock[i].stockDt;
            var quantity = lstMstStock[i].quantity;

            var row = document.createElement('tr');
            row.id = id;
            row.onclick = (e) => {
                $(e.currentTarget).addClass('selected').siblings().removeClass('selected');
                var stockLocationId = $('#stockTableBody tr.selected').find('td:eq(0)').text();
                this.setStockForm(stockLocationId);
                this.setState({ flg: false })
            }

            if (stockLocation != null && stockLocation.toLowerCase().indexOf(filterStock) === -1)
                continue;
            if (designNoColor != null && designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
                continue;
            if (batchNo != null && batchNo.toLowerCase().indexOf(filterBatchNo) === -1)
                continue;

            this.addTD(row, id, 'no-display');
            this.addTD(row, stockLocationId, 'no-display');
            this.addTD(row, stockLocation, '');
            this.addTD(row, designId, 'no-display');
            this.addTD(row, designNoColor, '');
            this.addTD(row, batchNo, '');
            this.addTD(row, folioNo, '');
            this.addTD(row, quantity, 'text-right');
            this.addTD(row, stockDt, 'text-center');

            tbody.append(row);
        }
        table.append(tbody);
    }

    addTD(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        var text = document.createTextNode(val);
        cell.append(text);
        row.append(cell);
    }

    setStockForm = (id) => {
        var stockData = this.getStockData(id);
        if (stockData !== -1) {
            $('#stockLocationCmb').val(stockData.stockLocationId);
            $('#input_designColor').val(stockData.designNoColor);
            $('#batchNo').val(stockData.batchNo);
            $('#folioNo').val(stockData.folioNo);
            $('#quantity').val(stockData.quantity);
            $(".css-1wa3eu0-placeholder").html(stockData.designNoColor);
            $(".css-1uccc91-singleValue").html(stockData.designNoColor);


            var date = stockData.stockDt;
            date = date.split('-');

            var setDate = date.reverse().join();
            setDate = setDate.replace(/,/g, '-');
            var startDate = new Date(setDate);
            this.setState({
                startDate: startDate,
            });

        }
    }

    getStockData(id) {
        for (var i = 0; i < lstMstStock.length; i++) {
            if (id == lstMstStock[i].stockId) {
                return lstMstStock[i];
            }
        }
        return -1;
    }

    addStockReady = () => {
        $('#stockAddForm').trigger('reset');
        $('#stockTableBody tr.selected').removeClass('selected');
        $(".css-1uccc91-singleValue").html('Select...');
        $(".css-1uccc91-singleValue").attr('class', 'css-1wa3eu0-placeholder');
        $(".css-1wa3eu0-placeholder").html('Select...');


        this.setState({
            flg: true,
            startDate: null,
        });
    }

    maintainStock = () => {
        if (this.state.flg) {
            this.addStock();
        } else {
            this.editStock();
        }
    }

    getDesignId(designNoColor) {
        for (var i = 0; i < lstDesigns.length; i++) {
            if (designNoColor == lstDesigns[i].designNoColor) {
                return lstDesigns[i];
            }
        }
        return -1;
    }

    addStock = () => {
        var stockArr = {};
        var stockId = 0;
        var stockLocationId = $('#stockLocationCmb').find('option:selected').val();
        var stockLocation = $('#stockLocationCmb').find('option:selected').text();

        var batchNo = $('#batchNo').val();
        var folioNo = $('#folioNo').val();
        var quantity = $('#quantity').val();
        var stockDate = $('#stockDate').val();
        var designNoColor1 = $(".css-1wa3eu0-placeholder").html();
        var designNoColor2 = $(".css-1uccc91-singleValue").html();
        var designNoColor = "";
        if (designNoColor2 == undefined || designNoColor2 == "") {
            designNoColor = designNoColor1;
        }
        else {
            designNoColor = designNoColor2;
        }

        var objDesign = this.getDesignId(designNoColor);
        var designId = objDesign.designId;

        if (stockLocationId == 0) {
            toast.warning('Please Select Valid stock location');
            document.getElementById('stockLocationCmb').focus();
            return false;
        }
        if (designNoColor == undefined || designNoColor == "Select...") {
            toast.warning('Please Fill Design Color');
            return false;
        }
        if (batchNo == '') {
            toast.warning('Please Fill Batch Number');
            $('#batchNo').focus();
            return false;
        }
        if (folioNo == '') {
            toast.warning('Please Fill Folio Number');
            $('#folioNo').focus();
            return false;
        }
        if (quantity == '') {
            toast.warning('Please Fill Quantity');
            $('#quantity').focus();
            return false;
        }
        if (stockDate == '') {
            toast.warning('Please Fill Date');
            $('#stockDate').focus();
            return false;
        }


        stockArr = {
            'stockId': stockId, 'stockLocationId': stockLocationId, 'designId': designId,
            'batchNo': batchNo, 'folioNo': folioNo, 'quantity': quantity, 'stockDt': stockDate
        }
        this.setState({ loader: 'block', opacity: 0.5 });
        axiosInstance.post(httpURL + '/a/mst/stk/save',
            queryString.stringify({ 'stock': JSON.stringify(stockArr) }), { withCredentials: true }
        ).then((response) => {
            if (response.data.SvcStatus === "Success") {
                toast.success(response.data.SvcMsg);
                stockArr.stockId = response.data.stockId;
                stockArr.stockLocation = stockLocation;
                stockArr.designNoColor = designNoColor;
                lstMstStock.push(stockArr);
                this.setStockTable();
                this.setStockForm(response.data.stockId);
                this.highlightRow('stockTableBody', response.data.stockId);
                this.setState({ flg: false })
            }
            else {
                toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((e) => {
            toast.error("Service failed " + e);
        });
    }

    editStock = () => {
        var stockArr = {};
        var stockId = $('#stockTableBody tr.selected').find('td:eq(0)').text();
        var stockLocationId = $('#stockLocationCmb').find('option:selected').val();
        var stockLocation = $('#stockLocationCmb').find('option:selected').text();
        var batchNo = $('#batchNo').val();
        var folioNo = $('#folioNo').val();
        var quantity = $('#quantity').val();
        var stockDate = $('#stockDate').val();

        var designNoColor1 = $(".css-1wa3eu0-placeholder").html();
        var designNoColor2 = $(".css-1uccc91-singleValue").html();
        console.log(designNoColor1);
        console.log(designNoColor2);
        var designNoColor = "";
        if (designNoColor2 == undefined || designNoColor2 == "") {
            designNoColor = designNoColor1;
        }
        else {
            designNoColor = designNoColor2;
        }

        var objDesign = this.getDesignId(designNoColor);
        var designId = objDesign.designId;
        console.log(designNoColor);

        if (stockLocationId == 0) {
            toast.warning('Please Select Valid stock location');
            document.getElementById('stockLocationCmb').focus();
            return false;
        }
        if (designNoColor == undefined || designNoColor == "Select...") {
            toast.warning('Please Fill Design Color');
            return false;
        }
        if (batchNo == '') {
            toast.warning('Please Fill Batch Number');
            $('#batchNo').focus();
            return false;
        }
        if (folioNo == '') {
            toast.warning('Please Fill Folio Number');
            $('#folioNo').focus();
            return false;
        }
        if (quantity == '') {
            toast.warning('Please Fill Quantity');
            $('#quantity').focus();
            return false;
        }
        if (stockDate == '') {
            toast.warning('Please Fill Date');
            $('#stockDate').focus();
            return false;
        }


        stockArr = {
            'stockId': stockId, 'stockLocationId': stockLocationId, 'designId': designId,
            'batchNo': batchNo, 'folioNo': folioNo, 'quantity': quantity, 'stockDt': stockDate
        }
        this.setState({ loader: 'block', opacity: 0.5 });
        axiosInstance.post(httpURL + '/a/mst/stk/save',
            queryString.stringify({ 'stock': JSON.stringify(stockArr) }), { withCredentials: true }
        ).then((response) => {
            if (response.data.SvcStatus === "Success") {
                toast.success(response.data.SvcMsg);
                stockArr.stockLocation = stockLocation;
                stockArr.designNoColor = designNoColor;
                var stockIdx = this.getIdxStock(stockId);
                lstMstStock.splice(stockIdx, 1, stockArr);
                this.setStockForm(stockId);
                this.setStockTable();
                this.highlightRow('stockTableBody', stockId);
            }
            else {
                toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((e) => {
            toast.error("Service failed " + e);
        });
    }

    getIdxStock(stockId) {
        for (var i = 0; i < lstMstStock.length; i++) {
            if (lstMstStock[i].stockId == stockId) {
                return i;
            }
        }
        return -1;
    }

    highlightRow(table, id) {
        $('#' + table + ' tr').each(function () {
            var stockId = $(this).find('td:eq(0)').text();
            if (stockId == id) {
                $(this).addClass('selected').siblings().removeClass('selected');
            }
        });
    }

    async uploadExcel() {
        $("#excelUpload").click();
        $("#excelUpload").on('change', function (event) {
            if (!event.target.files) return;
            var files = event.target.files; //FileList object
            var files = files[0];
            var formData = new FormData();
            formData.append("stockExcelFile", files);
            axiosInstance({url: httpURL + '/a/mst/stk/excel/upload ',
                method:"POST",
                data: formData,
                withCredentials: true,
            }).then((response) => {
                if (response.data.SvcStatus === "Success") {
                    toast.success(response.data.SvcMsg);
                }
                else {
                    toast.error(response.data.SvcMsg);
                }
            }).catch((e) => {
                toast.error("Service failed " + e);
            });
        });


    }


    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <Header />
                <ToastContainer autoClose={2000} hideProgressBar />
                <div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
                    <img src={require("../images/loader.gif")} alt="Loader..." />
                </div>
                <div className="main" style={{ opacity: this.state.opacity }}>
                    <div className="container-fluid">
                        <div className="col-sm-11 col-centered">
                            <div className="col-sm-7 col-xs-11 padding-remove">
                                <table className="tableLayout tableWidth">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 50, display: 'none' }}>Stock Id</th>
                                            <th style={{ width: 50 }}>
                                                <input onChange={this.setStockTable} type="text" className="form-control inp-search" id="stockLocationFilter" placeholder="Stock Location" />
                                            </th>
                                            <th style={{ width: 70 }}>
                                                <input onChange={this.setStockTable} type="text" className="form-control inp-search" id="designColorFilter" placeholder="Design Number" />
                                            </th>
                                            <th style={{ width: 50 }}>
                                                <input onChange={this.setStockTable} type="text" className="form-control inp-search" id="batchNoFilter" placeholder="Batch Number" />
                                            </th>
                                            <th style={{ width: 40 }}> Folio No.</th>
                                            <th style={{ width: 40 }}> Quantity</th>
                                            <th style={{ width: 40 }}> Date</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div className="stockTableDiv col-sm-12 col-xs-11 padding-remove">
                                    <table id="stockTable" className="tableLayout">
                                        <colgroup>
                                            <col width="50" />
                                            <col width="70" />
                                            <col width="50" />
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="40" />
                                        </colgroup>
                                        <tbody id="stockTableBody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-sm-1 col-xs-1">
                                <span id="addStock" title="Add stock" onClick={this.addStockReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <form id="stockAddForm" className="form-horizontal">
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Stock Location:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <select type="text" className="form-control" placeholder="Stock" id="stockLocationCmb" />

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Design Color:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" style={{ display: 'none' }} className="form-control" placeholder="Design Id" id="input_designId" />
                                            <Select options={lstDesignsColor} id="input_designColor" />
                                            {/* onChange={(values) => this.setValues(values)} */}
                                            {/* <input type="text" onClick={this.openDesignPopup.bind(this)} className="form-control" placeholder="Design Color" id="input_designColor" /> */}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Batch No:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control" placeholder="Batch Number" id="batchNo" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Folio No.:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control" placeholder="Folio Number" id="folioNo" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5 ">Quantity:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control text-right" placeholder="Quantity" id="quantity" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Date:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <DatePicker id="stockDate"
                                                className='form-control text-center'
                                                placeholderText="Date"
                                                selected={this.state.startDate}
                                                onChange={this.handleChange}
                                                dateFormat="dd-MM-yyyy"
                                                autoComplete='off'
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginTop: 50 }}>
                                        <div className="col-sm-12 text-center">
                                            <button type="button" onClick={this.maintainStock} className="btn btn-warning">Save</button>
                                        </div>
                                    </div>
                                    <div className="importWrap">
                                        <div className="seperateOr">Or</div>
                                        <button id='uploadeExcel' title="Upload Excel" type="button" onClick={this.uploadExcel} className="btn btn-warning">Import Stock</button>
                                        <input type="file" id="excelUpload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default mstStock;